import PropTypes from "prop-types"
import { useRef } from "react"
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"
import styles from "../../../styles/Login.module.css"

export default function LoginScreen({
  maintenanceInfo,
  maintenanceDisabled,
  loading,
  user,
  password,
  onSubmit,
  onUserChange,
  onPasswordChange,
  onForgotPassword,
}) {
  const passwordInputRef = useRef(null)

  if (maintenanceInfo.maintenance_mode) {
    return (
      <div className={styles.centerText}>
        <h4>{maintenanceInfo.title}</h4>
        <p className={styles.stackGap}>{maintenanceInfo.message}</p>
        <p>{maintenanceInfo.updated_at}</p>
      </div>
    )
  }

  return (
    <>
      <h2>Login</h2>
      <form onSubmit={onSubmit} className="form-section">
        <div className="form-field">
          <label htmlFor="email">Email</label>
          <InputText
            id="email"
            type="email"
            autoComplete="username"
            value={user}
            onChange={({ target: { value } }) => {
              onUserChange(value)
            }}
            onKeyDown={(event) => {
              if (event.key !== "Enter") return

              //If there is no password set, select the password field. 
              if (!password) {
                event.preventDefault()
                passwordInputRef.current?.focus()
                passwordInputRef.current?.select()
                return
              }

              // Submit from the email field when password is already present.
              event.preventDefault()
              event.currentTarget.form?.requestSubmit()
            }}
            disabled={maintenanceDisabled || loading}
          />
        </div>
        <div className="form-field">
          <label htmlFor="pass">Password</label>
          <InputText
            id="pass"
            type="password"
            ref={passwordInputRef}
            value={password}
            onChange={({ target: { value } }) => {
              onPasswordChange(value)
            }}
            disabled={maintenanceDisabled || loading}
          />
        </div>
        <Button
          label={loading ? "Signing in..." : "Sign In"}
          type="submit"
          className={`btn ${styles.actionBtn}`}
          loading={loading}
          disabled={
            loading ||
            maintenanceDisabled ||
            !user ||
            !password
          }
        />
      </form>

      <button
        className={styles["plain-text-link"]}
        onClick={() => {
          if (loading) return
          onForgotPassword()
        }}
        type="button"
      >
        Forgot your password?
      </button>
    </>
  )
}

LoginScreen.propTypes = {
  maintenanceInfo: PropTypes.object.isRequired,
  maintenanceDisabled: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  user: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onUserChange: PropTypes.func.isRequired,
  onPasswordChange: PropTypes.func.isRequired,
  onForgotPassword: PropTypes.func.isRequired,
}
